<template>
  <div class="popup-wrapper" @click.self="close">
    <div class="popup-action">
      <div class="button button-submit">
        <div role="button" class="btn"
          @click="action.save"
        >決定
        </div>
      </div>
      <div class="button button-close">
        <button class="btn" @click="close">
          <FontawesomeIcon :icon="['fal','times']" size="lg" class="icn" />
        </button>
      </div>
    </div>
    <div class="popup-container">
      <div class="popup">
        <div class="popup-title">
          <span class="popup-title-main hdg02">ブックマークの編集</span>
        </div>
        <div class="popup-content-box">
          <div class="popup-content-block popup-content-block-01">
            <p class="popup-content-block-title">ブックマークのタイトル</p>
            <div class="formparts text">
              <input type="text" v-model="data.name">
              <p v-if="validation.isSubmit && !validation.title.require" class="error-message">タイトルは必須です</p>
            </div>
          </div>
          <div class="popup-content-block popup-content-block-02">
            <p class="popup-content-block-title">タグの指定</p>
            <div class="formparts function">
              <input @keydown.enter="action.enterInput" type="text" v-model="data.tagInput">
              <div @click="action.insertTag" class="button" role="button"><span class="icn register">登録</span></div>
            </div>

            <span v-if="data.allTags.length > 0" class="txt-blue" role="button"
              @click="state.isOpenHistoryTags = !state.isOpenHistoryTags"
              :class="{'is-open' : state.isOpenHistoryTags}"
            >
              登録済のタグから追加
              <FontawesomeIcon icon="angle-down" class="icn down" />
              <FontawesomeIcon icon="angle-up" class="icn up" />
            </span>

            <div class="tags-history mt8"
              v-if="state.isOpenHistoryTags && data.allTags.length > 0"
            >
              <div v-for="(tag, index) in data.allTags" :key="'history_' + index" class="tag bottom">
                <div @click="action.settingTag(tag)" role="button" class="tag-wrap">
                  <span class="tag-text">{{tag.name}}</span>
                </div>
              </div>
            </div>

            <div class="mt8">
              <div v-for="(tag, index) in data.tags" :key="'setting_' + index" class="tag">
                <div @click="action.removeTag(tag)" role="button" class="tag-wrap">
                  <span class="tag-text">{{tag.name}}</span>
                  <span class="tag-close"><FontawesomeIcon icon="times" size="xs" class="icn" /></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, ref, computed } from '@vue/composition-api'

import { BookmarkEdit } from '@/logic/bookmark/BookmarkEdit'

export default defineComponent({
  setup (props, context) {
    return { ...BookmarkEdit(props, context) }
  }
})
</script>

<style lang="scss" scoped>
.popup-content {
  padding: 20px;
  background-color: $color-bg-form;
  border-radius: 0 0 4px 4px;
  &-box {
    background-color: #fff;
    border-radius: 4px;
  }
  &-block {
    border-bottom: 1px solid $color-line;
    padding: 20px;
    &:last-child {
      border-bottom: 0;
    }
    &-title {
      color: $color-hdg;
      font-size: 1.8rem;
      font-weight: bold;
      margin-bottom: 16px;
    }
    &-02 {
      .txt-blue {
        text-align: center;
        display: block;
        font-size: 1.4rem;
        margin-top: 20px;
        .up {
          display: none;
        }
        &.is-open {
          .up {
            display: inline;
          }
          .down {
            display: none;
          }
        }
      }
      .tags-history {
        padding-bottom: 20px;
        border-bottom: 1px solid $color-line;
      }
    }
  }
}
</style>
